import { type ParsedUrlQuery } from 'querystring'
import { type UrlObject } from 'url'

import { type CompanyEmployeeToken } from '@/legacy-src/types/UserStateType'

export enum AuthPageMode {
  DIAGNOSIS = 'diagnosis',
  EMPLOYEE = 'employee',
  RESERVATION = 'reservation',
  DEFAULT = 'default',
}

export const VALID_AUTH_PAGE_MODES = Object.values(AuthPageMode).filter((mode) => mode !== AuthPageMode.DEFAULT)

export const getAuthPageModeFromQuery = (query: ParsedUrlQuery): AuthPageMode => {
  const modeInUrl = Array.isArray(query.mode) ? query.mode[0] : query.mode
  return modeInUrl && VALID_AUTH_PAGE_MODES.includes(modeInUrl as any)
    ? (modeInUrl as AuthPageMode)
    : AuthPageMode.DEFAULT
}

export const getAuthPageUrl = (page: 'login' | 'register', query: ParsedUrlQuery): UrlObject => {
  const mode = getAuthPageModeFromQuery(query)
  const url = `/${page}${mode && mode !== AuthPageMode.DEFAULT ? `/${mode}` : ''}`
  return { pathname: url, query }
}

export const getCompanyEmployeeFromQuery = (query: ParsedUrlQuery): CompanyEmployeeToken => {
  const companyEmployee = {
    slug: query['companyEmployee[slug]'],
    // in some places we use email instead of companyEmail. This is a temporary fix to support both for the migration
    companyEmail: query['companyEmployee[companyEmail]'] || query['companyEmployee[email]'],
    activationLinkId: query['companyEmployee[activationLinkId]'],
    blinkClientId: query['companyEmployee[blinkClientId]'],
    token: query['companyEmployee[token]'],
    code: query['companyEmployee[code]'],
  } as CompanyEmployeeToken

  Object.keys(companyEmployee).forEach((key) => {
    if (companyEmployee[key] === undefined) {
      delete companyEmployee[key]
    }
  })

  return companyEmployee
}

export const isCompanyEmployeeInQuery = (query: ParsedUrlQuery): boolean => {
  return Boolean(query['companyEmployee[token]'])
}
